import { Tooltip } from "antd";
import moment from "moment";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import RejectAmendmentModal from "@/Components/modals/client/RejectAmendmentModal";
import SignOffModal from "@/Components/modals/timesheet/SignOffModal";
import { ACTION_BTN_HOVER_CLR } from "@/Constants/common";
import {
  fetchAssignedTimesheets,
  toggleRejectModal,
  toggleSignOffModal,
  updatePagination,
  setAssignedTimesheetsLoading,
  toggleSignOffModalData,
  updateToggleSelected,
  updateSelectedTimesheets,
} from "@/reducers/timesheets/timesheetassigned";
import { fetchTimesheetCount } from "@/reducers/timesheets/timesheets";
import { TOOLTIPTEXT, toastMessageText } from "@/utilities/CommonText";
import { showCommonToast, showErrorToast } from "@/utilities/utils";

import ActionIcons from "../../../ActionIcons";

const Actions = ({ diffList, setDiffList }) => {
  const {
    pagination,
    showRejectModal,
    assignedTimesheets,
    selectedSignOffIds,
    selectedTimesheets,
    selectedCandidate,
    isSelectedAll,
    showSignOffModal,
    selectedSignOffData,
  } = useSelector((state) => state.timesheetAssigned);
  const { clientUserAllPermissions } = useSelector((state) => state.session);
  const { user } = useSelector((state) => state.clientProfile);
  const dispatch = useDispatch();
  const [reason, setReason] = useState("");
  // const [approveLoading, setApproveLoading] = useState(false);
  // const [rejectLoading, setRejectLoading] = useState(false);
  // const [editLoading, setEditLoading] = useState(false);
  const handleReloadTable = () => {
    dispatch(fetchTimesheetCount());
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(setAssignedTimesheetsLoading(true));
    dispatch(fetchAssignedTimesheets());
  };
  // const approveAmendment = (data) => {
  //   if (approveLoading) return;
  //   setApproveLoading(true);
  //   const response = _approveAmendment(data);
  //   response
  //     .then((res) => {
  //       const {
  //         data: { message },
  //       } = res;
  //       showSuccessToast(message);
  //       handleReloadTable();
  //     })
  //     .catch((error) => {
  //       handleAPICatch(error);
  //     })
  //     .finally(() => {
  //       setApproveLoading(false);
  //     });
  // };
  // const rejectAmendment = (data) => {
  //   if (rejectLoading) return;
  //   setRejectLoading(true);
  //   const response = _rejectAmendment(data);
  //   response
  //     .then((res) => {
  //       const {
  //         data: { message },
  //       } = res;
  //       dispatch(deSelectAllCandidate());
  //       showSuccessToast(message);
  //       handleReloadTable();
  //       // dispatch(fetchCandidateTypes());
  //     })
  //     .catch((error) => {
  //       handleAPICatch(error);
  //     })
  //     .finally(() => {
  //       setRejectLoading(false);
  //       setReason("");
  //       dispatch(toggleRejectModal(false));
  //     });
  // };
  // const showAdjustAmendment = (data) => {
  //   if (editLoading) return;
  //   setEditLoading(true);
  //   const { signoff_id } = data;
  //   const response = _showAdjustAmendment(data);
  //   response
  //     .then((res) => {
  //       const {
  //         data: { data, message },
  //       } = res;
  //       let adjustData = formatAdjustAmendmentData(data);
  //       dispatch(
  //         updateAdjustAmendmentData({
  //           ...adjustData,
  //           signOffId: signoff_id,
  //         }),
  //       );
  //       dispatch(toggleAdjustAmendmentModal(true));
  //       dispatch(deSelectAllCandidate());
  //     })
  //     .catch((error) => {
  //       handleAPICatch(error);
  //     })
  //     .finally(() => {
  //       setEditLoading(false);
  //     });
  // };
  // useEffect(() => {
  //   if (reason !== "") {
  //     dispatch(toggleRejectModal(true));
  //     rejectAmendment({
  //       signoff_id: selectedSignOffIds.join(","),
  //       reason: reason,
  //       isSelectedAll: isSelectedAll,
  //       page: SELECT_EXPORT_PAGES.ASSIGNED,
  //       ignoreIds: isSelectedAll
  //         ? assignedTimesheets
  //             .filter((ele) => !selectedSignOffIds.includes(ele.sign_off_id))
  //             .map((ele) => ele.sign_off_id)
  //             .join(",")
  //         : "",
  //     });
  //   }
  // }, [reason]);
  // const getNoEditRequiredIds = () => {
  //   // let Ids = [];
  //   // selectedSignOffIds.map((id) => {
  //   //   let selectedObj = assignedTimesheets.find(
  //   //     (item) => item.sign_off_id === id,
  //   //   );
  //   //   if (selectedObj.has_edit_required) {
  //   //     Ids.push(id);
  //   //   }
  //   // });
  //   const Ids = selectedSignOffIds.filter((id) => {
  //     const selectedObj = assignedTimesheets.find(
  //       (item) => item.sign_off_id === id,
  //     );
  //     return selectedObj.has_edit_required;
  //   });
  //   return Ids;
  // };

  return (
    <>
      <RejectAmendmentModal
        open={showRejectModal}
        callbackFunc={(val) => {
          const { reason } = val;
          setReason(reason);
        }}
        handleClose={() => {
          dispatch(toggleRejectModal(false));
        }}
      />
      <SignOffModal
        callbackFunc={() => {
          handleReloadTable();
        }}
        toggleSignOffModal={toggleSignOffModal}
        updateSelectedTimesheets={updateSelectedTimesheets}
        showSignOffModal={showSignOffModal}
        selectedTimesheets={selectedTimesheets}
        formData={{
          startTime: selectedSignOffData?.start_time,
          endTime: selectedSignOffData?.end_time,
          breakTime: selectedSignOffData?.break_time,
          adminTime: selectedSignOffData?.admin_time,
          noOfVisit: selectedSignOffData?.no_of_visit,
        }}
      />
      <div className="Actions_Wrapper tour-submitted-actions">
        <div className="flex h-[40px] cursor-pointer overflow-hidden rounded-lg bg-grey [&>*:last-child]:border-r-0 [&>*]:grid [&>*]:w-[56px] [&>*]:min-w-[56px] [&>*]:place-items-center [&>*]:border-0 [&>*]:border-r [&>*]:border-r-[#E5E6E9] [&>*]:text-txtColor">
          {!clientUserAllPermissions ||
          clientUserAllPermissions.is_allow_to_signoff_timesheets !== 0 ? (
            <>
              {/* <Tooltip title={TOOLTIPTEXT.authorise}>
                <div
                  className={`group ${ACTION_BTN_HOVER_CLR.green}`}
                  onClick={() => {
                    if (selectedSignOffIds.length > 0) {
                      let Ids = getNoEditRequiredIds(); // ids which required edit
                      let noEditRequiredArr = _.difference(
                        selectedSignOffIds,
                        Ids,
                      ); // if no edit required is selected
                      let editRequiredArr = _.intersection(
                        selectedSignOffIds,
                        Ids,
                      );
                      if (editRequiredArr.length > 0 && !isSelectedAll) {
                        setDiffList(editRequiredArr);
                        showErrorToast(
                          "timesheet which required edit can't be approved. Please amend the timesheet and try again.",
                        );
                        return;
                      }
                      if (noEditRequiredArr.length > 0) {
                        dispatch(deSelectAllCandidate());
                        approveAmendment({
                          signoff_id: noEditRequiredArr.join(","),
                          isSelectedAll: isSelectedAll,
                          page: SELECT_EXPORT_PAGES.SUBMITTED,
                          ignoreIds: isSelectedAll
                            ? assignedTimesheets
                                .filter(
                                  (ele) =>
                                    !selectedSignOffIds.includes(
                                      ele.sign_off_id,
                                    ),
                                )
                                .map((ele) => ele.sign_off_id)
                                .join(",")
                            : "",
                        });
                      } else {
                        showErrorToast(
                          "No Timesheet to approve. Please select another.",
                        );
                      }
                    } else {
                      showCommonToast(toastMessageText.noCandidateSelected, {
                        id: "no-candidate-selected",
                      });
                    }
                  }}
                >
                  <ActionIcons isLoading={approveLoading} type={"approve"} />
                </div>
              </Tooltip> */}
              {/* <Tooltip title={TOOLTIPTEXT.reject}>
                <div
                  className={`group ${ACTION_BTN_HOVER_CLR.red}`}
                  onClick={() => {
                    if (selectedCandidate.length > 0) {
                      dispatch(toggleRejectModal(true));
                    } else {
                      showCommonToast(toastMessageText.noCandidateSelected, {
                        id: "no-candidate-selected",
                      });
                    }
                  }}
                >
                  <ActionIcons isLoading={rejectLoading} type={"reject"} />
                </div>
              </Tooltip> */}
              <Tooltip title={TOOLTIPTEXT.signOff}>
                <div
                  className={`group ${ACTION_BTN_HOVER_CLR.lightBlue} ${isSelectedAll ? "cursor-not-allowed opacity-50" : ""}`}
                  onClick={() => {
                    if (selectedTimesheets.length > 0) {
                      if (selectedTimesheets.length > 1) {
                        showCommonToast(toastMessageText.oneRecordToSignOff);
                      } else {
                        const selectedTimeSheet = selectedTimesheets[0];
                        const shiftDate = moment(
                          selectedTimeSheet.shift_date,
                          "DD/MM/YYYY",
                        );
                        if (shiftDate.isAfter(moment(), "day")) {
                          showErrorToast(
                            toastMessageText.noFutureShiftForSignoff,
                          );
                          dispatch(updateToggleSelected(false));
                          return;
                        }

                        //     // if (!selectedObj.has_edit_required) {
                        //     //   showErrorToast("No Edit Required");
                        //     //   return false;
                        //     // }
                        // dispatch(deSelectAllCandidate());
                        dispatch(toggleSignOffModal(true));
                        dispatch(toggleSignOffModalData(selectedTimesheets[0]));
                        dispatch(updateToggleSelected(false));
                        // showAdjustAmendment({
                        //   signoff_id: selectedSignOffIds[0],
                        // });
                      }
                      // console.log(getCandidateEmails());
                    } else {
                      showCommonToast(toastMessageText.noTimesheetSelected, {
                        id: "no-timesheet-selected",
                      });
                    }
                  }}
                >
                  <ActionIcons type={"edit"} />
                </div>
              </Tooltip>
            </>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default Actions;
